import { Box, Stack } from "@storyofams/react-ui";
import Image from "next/image";
import { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { FixedRatio } from "~components/common/FixedRatio";
import {
  USPLeaf,
  USPParabenFree,
  USPRabbit,
  USPSpray,
  USPTree,
} from "~components/common/Icons";
import { Iframe } from "~components/product/EmbeddedIframe";
import { IconsSellingPoints } from "~components/product/Header/SellingPoints";
import { ShopifyRichText } from "~components/product/ShopifyRichText";

const messages = defineMessages({
  crueltyFree: "Proefdiervrij",
  aboutThisPlantType: "Over deze plantsoort",
  alsoAvailableInBox: "Ook beschikbaar in onze DIY box!",
  natuurlijk: "100% natuurlijk",
  vegetarisch: "Vegetarisch",
  vegan: "Vegan",
  foodgrade: "Foodgrade",
  biologisch: "Biologisch",
  ongeraffineerd: "Ongeraffineerd",
  fairtrade: "Fair trade",
  alcohol_vrij: "Vrij van alcohol",
  parfumvrij: "Vrij van (synthetische) parfum",
  conserveringsmiddelen: "Vrij van conserveringsmiddelen",
  aardolie: "Vrij van minerale oliën (aardolie afgeleiden)",
  rotzooi:
    "Vrij van ftalaten, parabenen, minerale oliën, nano-deeltjes, SLS, triclosan, talc, siliconen, aluminium, Bisfenolen (BPA), PEG's, DEA, TEA, MEA",
});

const iconsByKey = {
  crueltyFree: USPRabbit,
  // natuurlijk: ,
  vegan: USPLeaf,
  vegetarisch: USPLeaf,
  biologisch: USPTree,
  // ongeraffineerd: ,
  // fairtrade: ,
  // alcohol_vrij: ,
  parfumvrij: USPSpray,
  // conserveringsmiddelen: ,
  // aardolie: ,
  rotzooi: USPParabenFree,
};

const usps = [
  "crueltyFree",
  "vegan",
  "vegetarisch",
  // 'natuurlijk',
  "biologisch",
  // 'ongeraffineerd',
  // 'fairtrade',
  // 'alcohol_vrij',
  "parfumvrij",
  // 'conserveringsmiddelen',
  // 'aardolie',
  "rotzooi",
];

export const Description = ({ description, product, getValue }) => {
  const intl = useIntl();
  const image = product?.metafields?.find(
    (item) =>
      item?.key === "description_image" && item?.namespace === "accentuate"
  )?.value;
  let imageJSON;
  if (image) {
    imageJSON = JSON.parse(image)?.[0];
  }
  const features = useMemo(
    () =>
      usps
        .filter(
          (usp) =>
            usp === "crueltyFree" ||
            (usp === "vegetarisch" ? !getValue("vegan") : !!getValue(usp))
        )
        .slice(0, 4)
        ?.map((usp) => ({
          icon: iconsByKey[usp],
          text: intl.formatMessage(messages[usp]),
        })),
    [product]
  );

  const mediaVideos = () => {
    const mediaFieldMedia = product?.metafields?.find(
      (item) => item?.key === "media_videos"
    );
    return mediaFieldMedia ? JSON.parse(mediaFieldMedia.value).videos : null;
  };

  return (
    <Stack space={[6, 100]} flexDirection={["column", "row"]}>
      <Box flex={1}>
        <Stack space={2} flexDirection="column">
          <ShopifyRichText
            content={description}
            mb={[5, 6]}
            styles={{
              ul: {
                pl: 2,
              },
            }}
          />
        </Stack>

        <IconsSellingPoints items={features} />
      </Box>

      <Box flex={1}>
        {!!imageJSON?.src && (
          <FixedRatio
            width="100%"
            ratio={[
              [343, 244],
              [589, 420],
            ]}
            position="relative"
            borderRadius="md"
            overflow="hidden"
          >
            <Image
              quality={50}
              layout="fill"
              objectFit="contain"
              objectPosition="center"
              src={imageJSON?.src}
              alt={imageJSON?.alt}
            />
          </FixedRatio>
        )}
        {mediaVideos()
          ? mediaVideos().map(({ uri, type }) => (
              <FixedRatio marginTop={2}>
                <Iframe key={uri} uri={uri} type={type} />
              </FixedRatio>
            ))
          : null}
      </Box>
    </Stack>
  );
};
